import axios from 'axios'
import getHeaders from '../helpers/headers'
import config from '../../constants/endpoints.js'

const createCrm = (data) => axios({
  method: 'post',
  url: config.endpoints.bitrix.createCrm,
  data,
  headers: getHeaders(true)
})

export default {
  createCrm
}
